import { DialogPositioningBehavior, DialogProps, DialogType, DialogWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { SaveConfirmationDialogBody } from './SaveConfirmationDialogBody';


export const IPALLOWLIST_SAVE_CONFIRMATION_DIALOG_TEST_ID = 'ipallowlist-save-confirmation-dialog';

export const openSaveConfirmationDialog = (message: string, onSave?: () => Promise<void>): void => {
    ReactModalService.openCustom(closeAndDismiss => {
        const dialogProps = ReactModalService.getDefaultDialogProps({
            type: DialogType.NormalWithTitleBar,
            title: Messages.ipAllowlistSaveConfirmationTitle(),
            testId: IPALLOWLIST_SAVE_CONFIRMATION_DIALOG_TEST_ID,
            showCloseButton: true,
            dialogWidth: TabDialogWidth.width400px,
            dialogHeight: TabDialogWidth.width200px,
            positioningBehavior: DialogPositioningBehavior.Draggable,
            shouldNotCloseOnGlassClick: true,
        }, closeAndDismiss);
        return getDialogWidget(dialogProps, closeAndDismiss, message, onSave);
    });
};

const getDialogWidget = (dialogProps: DialogProps, closeAndDismiss: CloseAndDismiss, message: string, onSave?: () => Promise<void>) => {
    return (
        <DialogWidget {...dialogProps}>
            <SaveConfirmationDialogBody message={message} closeAndDismiss={closeAndDismiss} onSave={onSave}/>
        </DialogWidget>
    );
};